/**
 * 使用量集計参照 APIクライアント（期間集計）
 */

import { AuthenticatedApiClient } from '../client';
import type {
  UsageAggregationLevel,
  UsageAggregationResponse,
  UsageDailyResponse,
} from '@/lib/types/usage/usageAggregation';

/** 使用量集計の取得条件（期間指定） */
export interface UsageAggregationParams {
  /** 集計期間の開始日 (YYYY-MM-DD)。省略時は to - 29 日 */
  from?: string;
  /** 集計期間の終了日 (YYYY-MM-DD)。省略時はデータ最新日 */
  to?: string;
  /** company (既定) / account */
  level: UsageAggregationLevel;
}

/**
 * 使用量集計を取得（認証付き）
 */
export async function getUsageAggregationAuthenticated(
  authHeaders: Record<string, string>,
  params: UsageAggregationParams,
): Promise<UsageAggregationResponse> {
  try {
    const client = new AuthenticatedApiClient(authHeaders);
    const queryParams = new URLSearchParams();
    if (params.from) queryParams.append('from', params.from);
    if (params.to) queryParams.append('to', params.to);
    queryParams.append('level', params.level);

    const url = `/usage-aggregation?${queryParams.toString()}`;
    return await client.get<UsageAggregationResponse>(url);
  } catch (error) {
    console.error('Failed to fetch usage aggregation:', error);
    throw error;
  }
}

/**
 * アカウント別の日次一覧（指定期間内）を取得（認証付き）
 */
export async function getUsageDailyAuthenticated(
  authHeaders: Record<string, string>,
  account: string,
  from?: string,
  to?: string,
): Promise<UsageDailyResponse> {
  try {
    const client = new AuthenticatedApiClient(authHeaders);
    const queryParams = new URLSearchParams();
    queryParams.append('account', account);
    if (from) queryParams.append('from', from);
    if (to) queryParams.append('to', to);

    const url = `/usage-aggregation/daily?${queryParams.toString()}`;
    return await client.get<UsageDailyResponse>(url);
  } catch (error) {
    console.error('Failed to fetch usage daily:', error);
    throw error;
  }
}
